import QRCode from 'qrcode'

// 接口返回信息判断输出

// 直接拼前缀访问
export function getImageUrlByPath(url) {
  return `${process.env.VUE_APP_BASE_URL + url}`
}

// 清除字段为 “” 为 {} 为[] 的  一般用于搜索条件
export function removeEmptyObj(obj) {
  const newObj = JSON.parse(JSON.stringify(obj))
  Object.keys(newObj).forEach(key => {
    if ((Object.prototype.toString.call(newObj[key]) === '[object String]' && newObj[key] === '') || (Object.prototype.toString.call(newObj[key]) === '[object Array]' && newObj[key].length === 0)) {
      delete newObj[key]
    } else if (Object.prototype.toString.call(newObj[key]) === '[object Object]') {
      removeEmptyObj(newObj[key])
    }
  })
  return newObj
}

// 验证文件大小
export function validFileSize(file, size = 50) {
  const isLt2M = file.size / 1024 / 1024 < size

  if (!isLt2M) {
    this.$message.error('文件大小不可超过' + size + 'M！')
  }
  return isLt2M
}

// 获取文件后缀
export const getFileType = (fileName) => {
  if (!fileName) return 'png'
  const fileIndex = fileName.lastIndexOf('.')
  const fileType = fileName.substr(fileIndex + 1)
  return isAssetTypeAnImage(fileType) ? 'png' : fileType
}

// 获取url地址的文件名称（包括文件后缀名）
export function getFileNameFromUrl(url) {
  var matches = url.match(/^.*\/([^?#]*)$/)
  return matches ? matches[1] : null
}

// 是否为图片
function isAssetTypeAnImage(ext) {
  return ['png', 'jpg', 'jpeg', 'bmp', 'gif', 'webp', 'psd', 'svg', 'tiff'].indexOf(ext.toLowerCase()) !== -1
}

// 对象转数组
export const objToArr = (obj) => Object.keys(obj).map(k => ({ key: k, value: obj[k] }))

// 下载public 文件
export function downloadPublicFile(path, filename) {
  // const origin = window.location.origin
  // const pathname = window.location.pathname
  const downloadElement = document.createElement('a')
  downloadElement.style.display = 'none'
  downloadElement.href = path
  downloadElement.download = filename
  document.body.appendChild(downloadElement)
  downloadElement.click() // 点击下载
  document.body.removeChild(downloadElement) // 下载完成移除元素
}

// 接口下载、导出 处理数据
export function downloadFileByResponse(response, pattKey) {
  const blob = new Blob([response.data])
  const downloadElement = document.createElement('a')
  const href = window.URL.createObjectURL(blob)
  const contentDisposition = response.headers['content-disposition'] // 从response的headers中获取filename, 后端response.setHeader("Content-disposition", "attachment; filename=xxxx.docx") 设置的文件名;
  const patt = new RegExp(pattKey + '=([^;]+\\.[^\\.;]+);*')
  const result = contentDisposition.match(/=([^;]+)/)
  console.log(result, response, '=====>')
  const filename = pattKey || decodeURI(result[1]) // 处理文件名,解决中文乱码问 题
  downloadElement.style.display = 'none'
  downloadElement.href = href
  downloadElement.download = filename // 下载后文件名
  document.body.appendChild(downloadElement)
  downloadElement.click() // 点击下载
  document.body.removeChild(downloadElement) // 下载完成移除元素
  window.URL.revokeObjectURL(href) // 释放掉blob对象
}

/*
* @param data  表格数据
* @param merge 需要合并的列字段名称数组
* @returns {*}
*/
export function mergeTableRow(data, merge) {
  if (!merge || merge.length === 0) {
    return data
  }
  merge.forEach((m) => {
    const mList = {}
    data = data.map((v, index) => {
      const rowVal = v[m]
      if (mList[rowVal] && mList[rowVal].newIndex === index) {
        mList[rowVal]['num']++
        mList[rowVal]['sortIndex']++
        mList[rowVal]['newIndex']++
        data[mList[rowVal]['index']][m + '-span'].rowspan++
        v[m + '-span'] = {
          rowspan: 0,
          colspan: 0
        }
      } else {
        mList[rowVal] = { sortIndex: 0, num: 1, index: index, newIndex: index + 1 }
        v[m + '-span'] = {
          rowspan: 1,
          colspan: 1
        }
      }
      return v
    })
  })
  return data
}

/*
* @param data  表格数据-有index 只支持一个字段合并
* @param merge 需要合并的列字段名称
* @returns {*}
*/
export function getTableDataRowSpan(tableData, key) {
  let tempIndex = 0
  return tableData.reduce((result, item) => {
    if (result.indexOf(item[key]) < 0) {
      result.push(item[key])
    }
    return result
  }, [])
    .reduce((result, keys) => {
      const children = tableData.filter((item) => item[key] === keys)
      tempIndex++
      result = result.concat(
        children.map((item, index) => ({
          ...item,
          [`${key}-span`]: {
            colspan: index === 0 ? 1 : 0,
            rowspan: index === 0 ? children.length : 0
          },
          [`tempIndex-span`]: {
            colspan: index === 0 ? 1 : 0,
            rowspan: index === 0 ? children.length : 0
          },
          tempIndex: tempIndex
        }))
      )
      return result
    }, [])
}

// 配合getTableDataRowSpan使用
export function objectSpanMethod({ row, column }) {
  const span = column['property'] + '-span'
  if (row[span]) {
    return row[span]
  }
}

/*
* base64转file
* @param dataUrl  base64路径
* @param fileName 文件名
* @returns {*}
*/
export function dataURLtoBlob(dataUrl, fileName) {
  const arr = dataUrl.split(',')
  const mime = arr[0].match(/:(.*?);/)[1]
  const bstr = atob(arr[1])
  let n = bstr.length
  const u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new File([u8arr], fileName, {
    type: mime
  })
}

export function createCodeText(httpUrl, qrText = '上传会议图片') {
  console.log('--生成二维码http--', httpUrl)
  const opts = {
    errorCorrectionLevel: 'H', // 容错级别
    type: 'image/png', // 生成的二维码类型
    quality: 1, // 二维码质量
    margin: 2, // 二维码留白边距
    width: 128, // 宽
    height: 128, // 高
    text: httpUrl, // 二维码内容
    color: {
      dark: '#000000', // 前景色
      light: '#fff'// 背景色
    }
  }
  return new Promise((resolve, reject) => {
    QRCode.toDataURL(httpUrl, opts, (err, url) => {
      if (err) {
        console.log('--生成二维码失败--', err)
        reject(err)
      } else {
        console.log('--二维码base64Text--', url)
        const imgView = new Image()
        imgView.src = url
        imgView.crossOrigin = 'anonymous'
        const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')
        imgView.onload = () => {
          canvas.width = opts.width
          canvas.height = opts.height + 14
          ctx.drawImage(imgView, 0, 0, opts.width, opts.height)
          // 文字
          if (qrText) {
            const textSize = 12
            // 设置字体
            ctx.font = 'bold ' + textSize + 'px Arial'
            const tw = ctx.measureText(qrText).width // 文字真实宽度
            const ftop = canvas.height - textSize // 根据字体大小计算文字top
            const fleft = (opts.width - tw) / 2 // 根据字体大小计算文字left
            const tp = textSize / 2 // 字体边距为字体大小的一半可以自己设置
            ctx.fillStyle = opts.color.light
            ctx.fillRect(
              fleft - tp / 2,
              ftop - tp / 2,
              tw + tp,
              textSize + tp
            )
            ctx.textBaseline = 'top' // 设置绘制文本时的文本基线。
            ctx.fillStyle = opts.color.dark
            ctx.fillText(qrText, fleft, ftop)
          }
          resolve(canvas.toDataURL('image/png'))
        }
      }
    })
  })
}

// 二维码
export function createCode(httpUrl) {
  console.log('--生成二维码http--', httpUrl)
  const opts = {
    errorCorrectionLevel: 'H', // 容错级别
    type: 'image/png', // 生成的二维码类型
    quality: 1, // 二维码质量
    margin: 2, // 二维码留白边距
    width: 128, // 宽
    height: 128, // 高
    text: httpUrl, // 二维码内容
    color: {
      dark: '#000000', // 前景色
      light: '#fff'// 背景色
    }
  }
  return new Promise((resolve, reject) => {
    QRCode.toDataURL(httpUrl, opts, (err, url) => {
      if (err) {
        console.log('--生成二维码失败--', err)
        reject(err)
      } else {
        console.log('--二维码base64--', url)
        resolve(url)
      }
    })
  })
}

// 将base64图片旋转90度以后上传
export function rotateBase64(data) {
  return new Promise((resolve) => {
    const imgView = new Image()
    imgView.src = data
    const canvas = document.createElement('canvas')
    const context = canvas.getContext('2d')
    const cutCoor = { sx: 0, sy: 0, ex: 0, ey: 0 } // 裁剪坐标
    imgView.onload = () => {
      const imgW = imgView.width
      const imgH = imgView.height
      const size = imgH
      canvas.width = size * 2
      canvas.height = size * 2
      cutCoor.sx = size
      cutCoor.sy = size - imgW
      cutCoor.ex = size + imgH
      cutCoor.ey = size + imgW
      context.translate(size, size)
      context.rotate(Math.PI / 2 * 3)
      context.drawImage(imgView, 0, 0)
      const imgData = context.getImageData(cutCoor.sx, cutCoor.sy, cutCoor.ex, cutCoor.ey)
      canvas.width = imgH
      canvas.height = imgW
      context.putImageData(imgData, 0, 0)
      resolve(canvas.toDataURL('image/png'))
    }
  })
}
